import * as React from 'react'
import { styled } from '@mui/material/styles'
import Checkbox from '@mui/material/Checkbox'
import { FormControlLabel, Tooltip } from '@mui/material'

const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 3,
    width: 16,
    height: 16,
    backgroundColor: '#E0E0E0',
    boxShadow:
    theme.palette.mode === 'dark'
        ? '0 0 0 1px rgb(16 22 26 / 40%)'
        : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2
    },
    'input:hover ~ &': {
        backgroundColor: '#E0E0E0'
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background:
      theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)'
    }
}))

const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#E0E0E0',
    '&::before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23008000'/%3E%3C/svg%3E\")", // Flecha verde más oscuro
        content: '""'
    },
    'input:hover ~ &': {
        backgroundColor: '#E0E0E0'
    }
})

const TooltipRender = ({ children, tooltipText, tooltipPosition }) => {
    return (
        <>
            { tooltipText
                ? (
                    <Tooltip title={tooltipText} placement={tooltipPosition} arrow>
                        { children }
                    </Tooltip>
                )
                : children
            }
        </>
    )
}

const OneCheckbox2 = ({ text, labelSize, tooltipText = false, tooltipPosition = 'bottom', newSx, ...props }) => {
    return (
        <FormControlLabel control={
            <TooltipRender tooltipText={tooltipText} tooltipPosition={tooltipPosition} >
                <Checkbox
                    sx={{
                        fontSize: labelSize,
                        '&:hover': { bgcolor: 'transparent' }
                    }}
                    disabled
                    color="default"
                    checkedIcon={<BpCheckedIcon />}
                    icon={<BpIcon />}
                    inputProps={{ 'aria-label': 'Checkbox demo' }}
                    {...props}
                />
            </TooltipRender>
        }
        label={text}
        sx={{
            '.MuiFormControlLabel-label': {
                ...{
                    color: 'black',
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                    overflowWrap: 'break-word'
                },
                ...newSx
            }
        }
        }
        />
    )
}

export default OneCheckbox2
